import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useRef } from 'react';
import { motion } from 'framer-motion';
import { useClickOutsideComponents } from '@che-ins-ui/utils';
import { useFocusOutside } from '@/libs/hooks';
import { useStyles } from './styles';
export const InputSuggestions = forwardRef(({ suggestions, onHover, onBlur, areSuggestionsShown, hideSuggestions, onClick, }, ref) => {
    const classes = useStyles();
    const suggestionsRef = useRef(null);
    const scrollToTop = () => {
        if (suggestionsRef.current) {
            suggestionsRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };
    const onOutsideEvent = () => {
        if (areSuggestionsShown) {
            setTimeout(hideSuggestions);
            scrollToTop();
        }
    };
    useClickOutsideComponents([ref], onOutsideEvent);
    useFocusOutside(ref, onOutsideEvent);
    if (suggestions.length === 0) {
        return null;
    }
    const animation = {
        opacity: areSuggestionsShown ? 1 : 0,
        y: areSuggestionsShown ? 0 : -10,
    };
    return (_jsx(motion.div, { initial: animation, animate: animation, transition: {
            y: { type: 'spring', stiffness: 600, damping: 20 },
            opacity: { duration: areSuggestionsShown ? 0.2 : 0.1 },
        }, className: classes.suggestionsWrapper, "data-shown": areSuggestionsShown, children: _jsx("div", { className: classes.suggestions, ref: suggestionsRef, children: suggestions.map((suggestion) => {
                const { _uuid, firstName, lastName } = suggestion;
                const props = {
                    key: _uuid,
                    name: `${lastName} ${firstName}`,
                    onHover: () => onHover(suggestion),
                    onBlur,
                    onClick: () => {
                        onClick(suggestion);
                    },
                    tabIndex: areSuggestionsShown ? 0 : -1,
                };
                return _jsx(Suggestion, { ...props });
            }) }) }));
});
const Suggestion = memo(({ name, onHover, onBlur, onClick, tabIndex }) => {
    const classes = useStyles();
    return (_jsx("button", { className: classes.nonNotebookSuggestion, onPointerEnter: onHover, onPointerLeave: onBlur, onClick: onClick, tabIndex: tabIndex, children: _jsx("p", { children: name }) }));
});
